angular.module('bmsApp.merrymaids.job').controller('MMBlankQuoteFormSelectionModalCtrl', function ($state,
																								   $scope,
																								   $modalInstance,
																								   MMHouseTemplateSvc) {

	function init() {
		self.form.type = "basic"; // set as default
        // NOTE::(Ashley) is this returning the hoseTemplate options or dose it require the roomType options, if so
        // use  MMHouseTemplateSvc.roomType.options()
		MMHouseTemplateSvc.options().then(function(response){
			self.houseTemplates = response.data.options;
		});
	}

	function confirmSelection() {
		$modalInstance.close(self.form);
	}

	function confirmDisabled() {
		return (self.form.type == 'template' && (angular.isUndefined(self.form.houseTemplate) || self.form.houseTemplate == null))
	}

	var self = {
		form: {
			houseTemplate: undefined
		},
		houseTemplates: null,
		methods: {
			confirmSelection: confirmSelection,
			confirmDisabled: confirmDisabled
		}
	};

	$scope.quoteFormSelectionCtrl = self;

	init();
});
